import { FormatPhonePipe } from '../../../../../../modules/mapfre-design-library/src/lib/_helpers/_pipes/format-phone.pipe';
import { CustomDateFormatPipe } from '../../../../../../_helpers/_pipes/custom-date-format.pipe';
import { BnPaynowModalComponent } from '../../bn-paynow-modal/bn-paynow-modal.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule , CurrencyPipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, Input, OnInit } from '@angular/core';
import { AcmicService, ModalOptions } from '@mapfre-design-library/src/public_api';
import { PaymentServiceService } from '@services/payment-service/payment-service.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, BnPaynowModalComponent, CustomDateFormatPipe, FormatPhonePipe],
  selector: 'app-bn-error-notice',
  templateUrl: './bn-error-notice.component.html',
  styleUrls: ['./bn-error-notice.component.scss'],
  providers: [CurrencyPipe],
})
export class BnErrorNoticeComponent implements OnInit {

  @Input() amount: string;
  @Input() date: string;
  @Input() agent: any;
  @Input() policyCancellationReason: string;
  @Input() pending = false;
  @Input() cancelled = true;
  @Input() source: string;
  payNowModal: ModalOptions;
  @Input() policy: any;
  hideModalOnRoute: any = false;
  isAcmic: boolean;
  agentPhoneNumber: string;
  hideAlertCancelled: boolean;
  hideAlertNonCancelled: boolean;
  constructor(
    private paymentService: PaymentServiceService,
    private currency: CurrencyPipe, private acmicService: AcmicService
  ) {
    this.payNowModal = new ModalOptions({
      additionalButtonClasses: 'btn-cancel',
      additionalClasses:
        'pay-now-modal  modal-medium modal-dialog center-on-page',
      buttonCopy: null,
      modalId: 'payNowCancel',
      modalTranslateCopy: 'MODAL_MAKE_A_PAYMENT',
      size: 'modal-medium',
      typeOfModal: 'default',
      modalName: 'deliquency_Pay_Now',
    });
  }

  hideModal() {
    this.hideModalOnRoute = false;
  }

  onPayByCardBilling(policyNumber, zipCode, minAmount) {
    this.paymentService.onPayByCard(policyNumber, zipCode, minAmount);
    this.hideModalOnRoute = true;
  }

  amountString() {
    return `pay ${this.currency.transform(this.amount)}`;
  }
  onCloseForNonCancelled() {
    this.hideAlertNonCancelled = true;
  }
  onClose() {
    this.hideAlertCancelled = true;
  }

  ngOnInit() {
    this.isAcmic = this.acmicService.isACMIC();
    this.agentPhoneNumber = this.policy?.agent?.agentISCPhone && this.policy?.agent?.agentISCPhone?.number
                              ? this.policy?.agent?.agentISCPhone?.number
                              : this.policy?.agent?.agentPhone?.number
    this.agentPhoneNumber = this.agentPhoneNumber?.toString().replace(/\D+/g, '');
  }

}
